// DisplayWebSocketMessageComponent.js

import React, { useEffect, useState } from 'react';
import { useWebSocket } from './WebSocketProvider';

const DisplayWebSocketMessageComponent = () => {
  const { messages, isConnected } = useWebSocket();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isConnected && messages.length > 0) {
      setVisible(true);
    }
  }, [isConnected, messages]);

  if (!visible || messages.length === 0) return null;

  // Filter out upload progress messages as they are handled by UploadProgressBar
  const filteredMessages = messages.filter(msg =>
    msg.type !== 'upload_start' &&
    msg.type !== 'upload_progress' &&
    msg.type !== 'upload_complete'
  );

  if (filteredMessages.length === 0) return null;

  return (
    <div className="websocket-messages">
      <h3>Üzenetek</h3>
      <ul>
        {filteredMessages.map((message, index) => (
          <li key={index}>
            {message.message || JSON.stringify(message)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DisplayWebSocketMessageComponent;
